// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuthDiv {
    background: linear-gradient(180deg, #ecf4ff, #f5fafe);
    position: relative;
    height: 100vh;
}

.loginDiv {
    background: #fff;
    border-radius: 26px;
    box-shadow: 0 12px 24px #0000000a;
    max-width: 30.2rem;
    padding: 1.8rem 2rem;
    position: relative;
}

.logoDiv {
    position: fixed;
    top: 20px;
    left: 20px;
}

.logo {
    max-width: 160px;
}

.logoCircleDiv {
    position: absolute;
    right: 30px;
    top: -50px;
    background: #fff;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    margin: auto;
    display: flex;
    align-items: baseline;
    justify-content: center;
    padding: 9px;
    box-shadow: 0 0.25rem 2.1rem rgba(133, 131, 218, 0.2);
}

.loginCirclelogo {
    width: 70px;
}

.imageCard {
    background: #fff;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    width: 100%;
    max-width: 500px;
    /* height: 250px; */
    margin: auto;
}

.carousel-indicators {
    bottom: -40px !important;
}

.carousel-indicators [data-bs-target] {
    background-color: var(--theme1) !important;
}`, "",{"version":3,"sources":["webpack://./src/Screen/Login/login.css"],"names":[],"mappings":"AAAA;IACI,qDAAqD;IACrD,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,YAAY;IACZ,qDAAqD;AACzD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":[".AuthDiv {\n    background: linear-gradient(180deg, #ecf4ff, #f5fafe);\n    position: relative;\n    height: 100vh;\n}\n\n.loginDiv {\n    background: #fff;\n    border-radius: 26px;\n    box-shadow: 0 12px 24px #0000000a;\n    max-width: 30.2rem;\n    padding: 1.8rem 2rem;\n    position: relative;\n}\n\n.logoDiv {\n    position: fixed;\n    top: 20px;\n    left: 20px;\n}\n\n.logo {\n    max-width: 160px;\n}\n\n.logoCircleDiv {\n    position: absolute;\n    right: 30px;\n    top: -50px;\n    background: #fff;\n    width: 90px;\n    height: 90px;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    margin: auto;\n    display: flex;\n    align-items: baseline;\n    justify-content: center;\n    padding: 9px;\n    box-shadow: 0 0.25rem 2.1rem rgba(133, 131, 218, 0.2);\n}\n\n.loginCirclelogo {\n    width: 70px;\n}\n\n.imageCard {\n    background: #fff;\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n    width: 100%;\n    max-width: 500px;\n    /* height: 250px; */\n    margin: auto;\n}\n\n.carousel-indicators {\n    bottom: -40px !important;\n}\n\n.carousel-indicators [data-bs-target] {\n    background-color: var(--theme1) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
